import styled from 'styled-components';

const TopNavMenuItem = styled.li`
   display: inline-block;
   line-height: ${({ theme }) => theme.sizes.siteHeaderHeight};
   white-space: nowrap;
`;

export { TopNavMenuItem };
